import React from 'react';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

const ErrorToast = (props) => {
 
    // toastr.remove();
    toastr.options.positionClass = props.position;
    toastr.error(props.text);

    return (
        <></>
    )
}

export default ErrorToast;
